/* OH Bubbles — theme.js. Minimal, restrained (design.md): mobile menu + subtle reveals. */
(function () {
  "use strict";

  /* Mobile nav toggle */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-menu-toggle]");
    if (toggle) {
      var nav = document.querySelector("[data-mobile-nav]");
      if (nav) {
        var open = nav.hasAttribute("hidden");
        if (open) { nav.removeAttribute("hidden"); } else { nav.setAttribute("hidden", ""); }
        toggle.setAttribute("aria-expanded", String(open));
        document.body.style.overflow = open ? "hidden" : "";
      }
    }
    if (e.target.closest("[data-menu-close]")) {
      var n = document.querySelector("[data-mobile-nav]");
      if (n) { n.setAttribute("hidden", ""); document.body.style.overflow = ""; }
    }
  });

  /* Subtle fade reveals — IntersectionObserver, honors reduced-motion via CSS */
  var els = document.querySelectorAll(".reveal");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("is-in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add("is-in"); io.unobserve(entry.target); }
    });
  }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
  els.forEach(function (el) { io.observe(el); });
})();
